import type { ReactNode } from "react";

interface ErrorComponentTypes {
  image?: React.ReactNode;
  title?: string;
  subTitle?: ReactNode;
  /** Automation hook — emitted as `data-ui-id` on the root element. */
  uiId?: string;
}

function ErrorComponent({ title, image, subTitle, uiId }: ErrorComponentTypes) {
  if (title || image || subTitle) {
    return (
      <div
        className="flex justify-center items-center flex-col gap-2"
        {...(uiId ? { "data-ui-id": uiId } : {})}
      >
        {image && <div>{image}</div>}
        {title && (
          <div className="text-base text-text-500 font-semibold text-center">
            {title}
          </div>
        )}
        {subTitle && (
          <div className="text-sm text-text-100 font-medium text-center">
            {subTitle}
          </div>
        )}
      </div>
    );
  }
  return null;
}

export default ErrorComponent;
